(function() { window.GUID_86568ece_68d5_4f1c_a0df_ddc6622dbde7 = { getGuid: function() { return "86568ece-68d5-4f1c-a0df-ddc6622dbde7"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let StatSection;
        (function (StatSection) {
            StatSection[StatSection["Standings"] = 0] = "Standings";
            StatSection[StatSection["Charts"] = 1] = "Charts";
            StatSection[StatSection["History"] = 2] = "History";
            StatSection[StatSection["MVP"] = 3] = "MVP";
            StatSection[StatSection["Compare"] = 4] = "Compare";
            StatSection[StatSection["CSR"] = 5] = "CSR";
        })(StatSection = Enumeration.StatSection || (Enumeration.StatSection = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StatSection.pre.js.map
